export const buildCartItemFromReorder = ({ element, item, type }) => {
  if (!item || !type) return null

  return {
    merchandiseId: element.merchandise_id,
    priceTypeId: element.price_type_id,
    size: element.size,
    packingId: 0,
    price: type.price,
    qty: Number(element.qty),
    amount: type.price * Number(element.qty),
    merchandiseName: item.display_name,
    typeName: type.name,
    image: element.image_url_1,
  }
}
